import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useEffect, useState } from 'react';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, Container, FormField, Input, Link, SpaceBetween, Wizard } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { formatRut } from '@fdograph/rut-utilities';
import { format } from 'date-fns';
import React from 'react';
import DPModal from '../../../../components/DPModal';
import Favorites from '../../../../components/extras/Favorites';
import PhoneInput from '../../../../components/PhoneInput';
import SelectCharges from '../../../../components/selects/SelectCharges';
import SelectCountry from '../../../../components/selects/selectCountry';
import SelectGroup from '../../../../components/selects/selectGroups';
import SelectUserType from '../../../../components/selects/selectUserTypes';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemUser } from '../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, formatPhone, getCookie, getUrlVersion, isEmail, setData, setLoading, validPhone } from '../../../commons/functions';
const _preserve = React.version;

export const MastersUserAddPage = () => {
    const { data, menu, parameters } = useGlobalState();
    const [activeStepIndex, setActiveStepIndex] = React.useState(0);
    const [newUser, setNewUser] = useState<ItemUser>();
    const [idCharges, setIdCharges] = useState<number[]>([]);
    const [idGroups, setIdGroups] = useState<number[]>([]);
    const [cancelButton, setCancelButton] = useState("");

    const initUser = () => {
        setNewUser({
            idUser: 0,
            phone1: "",
            RUT: "",
        } as ItemUser);
        setIdCharges([]);
        setIdGroups([]);
        setActiveStepIndex(0);
    }
    useEffect(() => {
        initUser()
    }, []);


    const handleCheckUser = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/get.light',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    phone1: newUser.phone1.replace(/\D/g, ''),
                    RUT: newUser.RUT,
                    TAX: true,
                    "columns": "idUser, displayName, RUT, phone1, email, isActiveUser, isDeleteUser, name, lastName"
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data.code == 0) {
                if (data.user === null) {
                    const rs = data.RUT.SII.razonSocial ?? "";
                    if (rs !== "") {
                        const nameParts = rs.split(' ');
                        let name = "", lastName = "";
                        if (nameParts.length === 3) {
                            name = nameParts[0]
                            lastName = nameParts.slice(1).join(' ')
                        } else if (nameParts.length === 4) {
                            name = nameParts.slice(0, 2).join(' ')
                            lastName = nameParts.slice(2).join(' ')
                        }


                        setNewUser((prev) => ({
                            ...prev,
                            name: name,
                            lastName: lastName,
                            displayName: setDisplayName(name, lastName)
                        } as ItemUser));
                    }
                    setActiveStepIndex(1);

                } else {
                    addNotification(`El usuario con móvil ${data.user.phone1} ya existe en el sistema. ID ${data.user.idUser}, ${data.user.displayName}`, "warning", setData);
                }
            } else {

            }
        } catch (error: any) {

        } finally { setLoading(false) }
    }


    const handleCreateUser = async () => {
        try {
            setLoading(true)
            let usr = {
                ...newUser,
                phone1: newUser.phone1.replace(/\D/g, ''),
                ...(idCharges.length > 0 && { idCharges: idCharges }),
                ...(idGroups.length > 0 && { idGroups: idGroups }),
                welcome: true,
                masters: ["users"],
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(
                    usr
                ),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                if (dataWeb.masters) {
                    const master = saveMasters(dataWeb.masters, data);
                    setData(master)

                }
                if (dataWeb.user && dataWeb.user.idUser !== 0) {
                    initUser();
                    setTimeout(() => {
                        //handleImageUpdate(dataWeb.user.idUser);
                    }, 200)
                }
            }
            addNotificationStatus(dataWeb, setData);
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);

        } finally { setLoading(false) }
    }

    const handleImageUpdate = async (idUser: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                timeout: 60000,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/update.image',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    idUser: idUser,
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
        } catch (error: any) {

        } finally { setLoading(false) }
    }
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={
                        <SpaceBetween size="xs" direction='horizontal'>
                            <Button href='#masters/users' variant='link'>Volver</Button>
                            <Favorites />
                        </SpaceBetween>
                    }>Ingresar usuario</Header>
                    <Wizard

                        i18nStrings={{
                            stepNumberLabel: stepNumber =>
                                `Paso ${stepNumber}`,
                            collapsedStepsLabel: (stepNumber, stepsCount) =>
                                `Paso ${stepNumber} de ${stepsCount}`,
                            skipToButtonLabel: (step, stepNumber) =>
                                `Salta a ${step.title}`,
                            navigationAriaLabel: "Pasos",
                            cancelButton: activeStepIndex !== 0 ? "Cancelar" : null,
                            previousButton: "Anterior",
                            nextButton: "Siguiente",
                            optional: "opcional"
                        }}
                        onCancel={() => {
                            initUser();
                        }}
                        onNavigate={({ detail }) => {
                            if (detail.requestedStepIndex === 2 && activeStepIndex === 1) {
                                if (newUser.name === "" || newUser.lastName === "" || !newUser.dateBirth || !newUser.dateMember) {
                                    addNotification("Todos los campos son obligatorios", "warning", setData);
                                    return;
                                }
                            }
                            else if (detail.requestedStepIndex === 3 && activeStepIndex === 2) {
                                if (!isEmail(newUser.email || "")) {
                                    addNotification("Debe proportcionar un email primario", "warning", setData);
                                    return;
                                }

                            }
                            else if (detail.requestedStepIndex === 1 && activeStepIndex === 0) {
                                if (!validPhone(newUser.phone1)) {
                                    addNotification("El campo móvil es obligatorio", "warning", setData);
                                    return;
                                }
                                if (!newUser.idCountry) {
                                    addNotification("El campo país es obligatorio", "warning", setData);
                                    return;
                                }

                                handleCheckUser();
                                return;
                            }
                            else if (detail.requestedStepIndex === 1 && activeStepIndex === 0) {
                                if (newUser.idCountry) {
                                    handleCheckUser();
                                } else {
                                    addNotification("El campo móvil es obligatorio", "warning", setData);
                                }
                                return;
                            }

                            setActiveStepIndex(detail.requestedStepIndex)
                        }}
                        activeStepIndex={activeStepIndex}
                        submitButtonText="Inicializar usuario"
                        onSubmit={() => {
                            if (!newUser.idUserType || newUser.idUserType === 0) {
                                addNotification("Debe seleccionar un tipo de usuario", "warning", setData);
                                return;
                            }
                            handleCreateUser()
                        }}
                        //allowSkipTo
                        steps={[
                            {
                                title: "Identificación del usuario",
                                description:
                                    "Verificación de número móvil para evitar duplicados en el sistema. Si el usuario ya existe, se mostrará una notificación con su información. RUT opcional recomendado, utilizado para autocompletar nombre y apellido si el usuario no existe.",
                                content: (
                                    <Container
                                    >
                                        <SpaceBetween direction="horizontal" size="l">

                                            <FormField label="Móvil">
                                                <PhoneInput placeholder="Ingrese teléfono del usuario" value={newUser?.phone1 ?? ""}

                                                    onChange={(detail) => {
                                                        setNewUser((prev) => ({
                                                            ...prev,
                                                            phone1: formatPhone(detail),
                                                        }));
                                                    }}
                                                />
                                            </FormField>

                                            <FormField label="RUT" constraintText={"*opcional"}>
                                                <Input value={newUser?.RUT || ""}
                                                    autoComplete="off"
                                                    onBlur={() => {
                                                        setNewUser((prev) => ({
                                                            ...prev,
                                                            RUT: formatRut(newUser?.RUT?.replace(/[^0-9kK]/g, '').toUpperCase())
                                                        } as ItemUser));
                                                    }}
                                                    onChange={(detail) => {
                                                        setNewUser((prev) => ({
                                                            ...prev,
                                                            RUT: detail.detail.value.toUpperCase()
                                                        } as ItemUser));
                                                    }}
                                                />
                                            </FormField>

                                            <FormField label="Nacionalidad">
                                                <SelectCountry value={newUser?.idCountry || null} onSelect={(id) => {
                                                    if (id)
                                                        setNewUser({ ...newUser, idCountry: id });
                                                }} />
                                            </FormField>

                                        </SpaceBetween>
                                    </Container>
                                )
                            },
                            {
                                title: "Información del usuario",
                                description:
                                    "Todos los campos de esta sección son requeridos.",
                                content: (
                                    <Container
                                    >
                                        <SpaceBetween direction="vertical" size="l">

                                            <FormField label="Nombres">
                                                <Input value={newUser?.name || ""}
                                                    autoComplete="off"
                                                    onChange={(detail) => {
                                                        setNewUser((prev) => ({
                                                            ...prev,
                                                            name: detail.detail.value.toUpperCase(),
                                                            displayName: setDisplayName(detail.detail.value, prev?.lastName || "")
                                                        } as ItemUser));
                                                    }}
                                                    onBlur={() => {
                                                        setNewUser((prev) => ({
                                                            ...prev,
                                                            name: newUser?.name?.trim(),
                                                            displayName: setDisplayName(newUser?.name?.trim(), prev?.lastName || "")
                                                        } as ItemUser));

                                                    }}
                                                />
                                            </FormField>

                                            <FormField label="Apellidos">
                                                <Input value={newUser?.lastName || ""}
                                                    autoComplete="off"
                                                    onChange={(detail) => {
                                                        setNewUser((prev) => ({
                                                            ...prev,
                                                            lastName: detail.detail.value.toUpperCase(),
                                                            displayName: setDisplayName(prev?.name || "", detail.detail.value)
                                                        } as ItemUser));
                                                    }}
                                                    onBlur={() => {
                                                        setNewUser((prev) => ({
                                                            ...prev,
                                                            lastName: newUser.lastName.trim(),
                                                            displayName: setDisplayName(prev?.name || "", newUser.lastName.trim())
                                                        } as ItemUser));

                                                    }}
                                                />
                                            </FormField>
                                            <FormField label="Nombre para mostrar">
                                                <Input value={newUser?.displayName || ""}
                                                    autoComplete="off"
                                                    onChange={(detail) => {
                                                        setNewUser((prev) => ({
                                                            ...prev,
                                                            displayName: detail.detail.value.toUpperCase()
                                                        } as ItemUser));
                                                    }}
                                                />
                                            </FormField>


                                            <SpaceBetween size="m" direction='horizontal'>
                                                <FormField label="Fecha nacimiento">
                                                    <DPModal
                                                        date={newUser?.dateBirth ?? ""}
                                                        end={new Date()}
                                                        yearPrev
                                                        yearNext
                                                        clear={false}
                                                        onConfirm={(date) => {
                                                            setNewUser((prev) => ({
                                                                ...prev,
                                                                dateBirth: date
                                                            } as ItemUser));
                                                        }} />
                                                </FormField>

                                                <FormField label="Fecha ingreso"
                                                    constraintText={<Link onClick={() => {
                                                        setNewUser((prev) => ({
                                                            ...prev,
                                                            dateMember: format(new Date(), "dd-MM-yyyy")
                                                        } as ItemUser));
                                                    }}>Hoy</Link>}
                                                >
                                                    <DPModal

                                                        clear={false}
                                                        end={new Date()}
                                                        yearPrev
                                                        yearNext

                                                        date={newUser?.dateMember ?? ""}
                                                        onConfirm={(date) => {
                                                            setNewUser((prev) => ({
                                                                ...prev,
                                                                dateMember: date
                                                            } as ItemUser));
                                                        }} />
                                                </FormField>
                                            </SpaceBetween>
                                        </SpaceBetween>
                                    </Container>
                                ),
                            },
                            {
                                title: "Información de contacto",
                                content: (
                                    <Container>
                                        <SpaceBetween direction="vertical" size="l">


                                            <FormField label="Email">
                                                <Input value={newUser?.email || ""}
                                                    autoComplete="off"
                                                    onChange={(detail) => {
                                                        setNewUser((prev) => ({
                                                            ...prev,
                                                            email: detail.detail.value.toLocaleLowerCase()
                                                        } as ItemUser));
                                                    }}
                                                />
                                            </FormField>
                                            <FormField label="Email alternativo" constraintText={"*opcional"}>
                                                <Input value={newUser?.email2 || ""}
                                                    autoComplete="off"
                                                    onChange={(detail) => {
                                                        setNewUser((prev) => ({
                                                            ...prev,
                                                            email2: detail.detail.value.toLocaleLowerCase()
                                                        } as ItemUser));
                                                    }}
                                                />
                                            </FormField>

                                        </SpaceBetween>
                                    </Container>
                                ),
                            },
                            {
                                title: "Cargos y grupos",
                                content: (
                                    <SpaceBetween size="xs">
                                        <Container>
                                            <SpaceBetween size="m" direction='vertical'>
                                                <FormField label={"Tipo de usuario"}>
                                                    <SelectUserType
                                                        single
                                                        onSelect={(selected: number) => {
                                                            setNewUser((prev) => ({
                                                                ...prev,
                                                                idUserType: selected
                                                            }))

                                                        }}
                                                        value={newUser?.idUserType ?? 0}

                                                    />
                                                </FormField>
                                                <FormField label="Cargos">
                                                    <SelectCharges
                                                        single={false}

                                                        onSelect={(selected: number[]) => {
                                                            setIdCharges(selected);
                                                        }}
                                                        value={idCharges ?? []}
                                                    />

                                                </FormField>
                                                <FormField label="Grupos">
                                                    <SelectGroup
                                                        single={false}

                                                        onSelect={(selected: number[]) => {
                                                            setIdGroups(selected);
                                                        }}
                                                        value={idGroups ?? []}
                                                    />

                                                </FormField>


                                            </SpaceBetween>
                                        </Container>
                                    </SpaceBetween>
                                )
                            }
                        ]}
                    />
                </SpaceBetween>
            }
        />
    )
};

function setDisplayName(name: string, lastName: string): string {
    const firstNameParts = name.trim().split(/\s+/).filter(Boolean);
    const lastNameParts = lastName.trim().split(/\s+/).filter(Boolean);
    const firstName = firstNameParts.length > 0 ? firstNameParts[0] : ""; // "Felipe"
    const firstLastName = lastNameParts.length > 0 ? lastNameParts[0] : ""; // "Brito"
    const secondLastNameInitial = lastNameParts.length > 1 ? lastNameParts[1].charAt(0) : null; // "P"
    return `${firstLastName.toUpperCase()}, ${firstName.toUpperCase()}`
}


export function saveMasters(masters: any, dataTemp: any) {
    if (masters && dataTemp) {
        if (masters.checks) { dataTemp.checks = masters.checks; }
        if (masters.accountPlans) { dataTemp.accountPlans = masters.accountPlans; }
        if (masters.bookingTypes) { dataTemp.bookingTypes = masters.bookingTypes; }
        if (masters.categories) { dataTemp.categories = masters.categories; }
        if (masters.charges) { dataTemp.charges = masters.charges; }
        if (masters.groupTypes) { dataTemp.groupTypes = masters.groupTypes; }
        if (masters.groups) { dataTemp.groups = masters.groups; }
        if (masters.usersStatuses) { dataTemp.usersStatuses = masters.usersStatuses; }
        if (masters.usersTypes) { dataTemp.usersTypes = masters.usersTypes; }
        if (masters.equipments) { dataTemp.equipments = masters.equipments; }
        if (masters.makes) { dataTemp.makes = masters.makes; }
        if (masters.users) { dataTemp.users = masters.users; }
        if (masters.complaintCategories) { dataTemp.complaintCategories = masters.complaintCategories; }
        if (masters.complaintTypes) { dataTemp.complaintTypes = masters.complaintTypes; }
        if (masters.countries) { dataTemp.countries = masters.countries; }

        localStorage.setItem("data", JSON.stringify(dataTemp))
        setData(dataTemp)
        return dataTemp;
    }
}